import React, { useState } from 'react'
import '../App.css'
import { URL_EXTENSION, SERVER_URI } from '../utility/config'
import { Link } from 'react-router-dom'
import ChangeCustomerInfo from './ChangeCustomerInfo'
import LoginRequest from './LoginRequest'
import axios from 'axios'

function CustomerList(props) {
  props.stopListRefresh()
  const [show, setShow] = useState({})
  const [isOpen, setIsOpen] = useState(false)
  const [popupInfo, setPopupInfo] = useState('')
  //const [isloggedIn, setIsloggedIn] = useState(true);
  const [filtered, setFiltered] = useState(false)
  const [filteredDel, setFilteredDel] = useState(false)
  const [searchChoice, setSearchChoice] = useState('')
  const [userData, setUserData] = useState({
    username: '',
    phoneNumber: '',
  })
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  /*  useEffect(() => {
        const fetchLogin = async () => {
            if (userToken === null) {
                console.log("kirjaudu sisään")
                setIsloggedIn(false)
            }
        }
        fetchLogin();
        // DON'T DELETE THE COMMENT BELOW!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) */

  const toggleComment = (id) => {
    setShow((prevShow) => ({ ...prevShow, [id]: !prevShow[id] }))
  }

  const togglePopup = (customer) => {
    setIsOpen(!isOpen)
    let customerInfo = {
      customerId: customer.customerId,
      phoneNumber: customer.phoneNumber,
      callSign: customer.callSign,
      accumulatedBonus: customer.accumulatedBonus,
    }
    setPopupInfo(customerInfo)
  }

  const togglePopupUpdate = (customer) => {
    setIsOpen(!isOpen)
  }
  const phonenumberSearch = (e) => {
    if (searchChoice === 'username' || searchChoice === '') {
      setSearchChoice('phonenumber')
    }
  }
  const usernameSearch = (e) => {
    if (searchChoice === 'phonenumber' || searchChoice === '') {
      setSearchChoice('username')
    }
  }
  const onChange = (e) => {
    /* setUserData({ ...userData, [e.target.name]: e.target.value }) */
    let lowerCase = e.target.value.toLowerCase()
    setUserData(lowerCase)
    setFiltered(true)
    setFilteredDel(true)
  }
  const filteredList = props.customerList.filter((item) => {
    if (searchChoice === 'username') {
      if (userData === '') {
        return item
      } else {
        return item.callSign.toLowerCase().includes(userData)
      }
    } else if (searchChoice === 'phonenumber') {
      if (userData === '') {
        return item
      } else {
        return item.phoneNumber.includes(userData)
      }
    } else return item
  })
  const filteredDelList = props.deletedCustomerList.filter((item) => {
    if (searchChoice === 'username') {
      if (userData === '') {
        return item
      } else {
        return item.callSign.toLowerCase().includes(userData)
      }
    } else if (searchChoice === 'phonenumber') {
      if (userData === '') {
        return item
      } else {
        return item.phoneNumber.includes(userData)
      }
    } else return item
  })

  const removeCustomer = async (
    customerId,
    phoneNumber,
    callSign,
    accBonus
  ) => {
    let res
    let dataToReducer = {
      customerId: customerId,
      callSign: callSign,
      accBonus: accBonus,
      phoneNumber: phoneNumber,
    }
    try {
      res = await axios.delete(`${SERVER_URI}/remove_customer/${customerId}`, {
        headers: { Authorization: `Token ${userToken}` },
      })
    } catch (e) {
      console.log('Error in deleting the customer', e)
    }
    console.log(res.data)
    props.dispatch({
      type: 'DELETE_CUSTOMER',
      data: { dataToReducer: dataToReducer, newId: res.data.customerId },
    })
  }

  const restoreCustomer = async (
    customerId,
    phoneNumber,
    callSign,
    accBonus
  ) => {
    let res
    let dataToReducer = {
      customerId: customerId,
      callSign: callSign,
      accBonus: accBonus,
      phoneNumber: phoneNumber,
    }
    try {
      res = await axios.delete(`${SERVER_URI}/restore_customer/${customerId}`, {
        headers: { Authorization: `Token ${userToken}` },
      })
      console.log('result: ', res.data)
      props.dispatch({
        type: 'RESTORE_CUSTOMER',
        data: { dataToReducer: dataToReducer, newId: res.data.customerId },
      })
    } catch (e) {
      console.log('Error restoring customer', e)
    }
  }

  return (
    <div className='customers_list'>
      <div>
        <div className='customer_listing'>
          <div className='checkboxes'>
            <h3 className='CustomerSearch_title'>Hae käyttäjää</h3>
            <input
              type='radio'
              id='phoneNumber'
              defaultChecked={searchChoice === 'phonenumber'}
              name='search'
              onClick={phonenumberSearch}
            ></input>
            <label htmlFor='PhonenumberSearch'>Puhelinnumero</label>
            <input
              type='radio'
              id='username'
              name='search'
              defaultChecked={searchChoice === 'username'}
              onClick={usernameSearch}
            ></input>
            <label htmlFor='UsernameSearch'>Käyttäjänimi</label>
          </div>
          <div
            className={searchChoice === 'username' ? 'searchUsername' : 'hide'}
          >
            <label htmlFor='username_field'>Etsi:</label>
            <input
              type='text'
              id='username'
              name='username'
              placeholder='Käyttäjänimi'
              onChange={onChange}
            ></input>
            <br />
          </div>
          <div
            className={
              searchChoice === 'phonenumber' ? 'searchPhonenumber' : 'hide'
            }
          >
            <label htmlFor='phonenumber_field'>Etsi:</label>
            <input
              type='text'
              id='phonenumber'
              name='phonenumber'
              placeholder='Puhelinnumero'
              onChange={onChange}
            ></input>
            <br />
          </div>
          <br />
          <h2>Asiakkaat</h2>
          {filtered === false ? (
            props.customerList === undefined ? (
              <LoginRequest />
            ) : props.customerList.length === 0 ? (
              <h4>Ei asiakkaita</h4>
            ) : (
              props.customerList.map((customer, index) => (
                <div
                  className='customer_list'
                  key={index}
                  id={customer.customerId}
                  onClick={() => toggleComment(customer.customerId)}
                >
                  {customer.callSign}
                  <br />
                  <div
                    className={show[customer.customerId] ? 'showCar' : 'hide'}
                  >
                    <span>Asiakkaan ID: </span>
                    <br className='mobile-break' /> {customer.customerId} <br />
                    <span>Asiakkaan puhelinnumero: </span>
                    <br className='mobile-break' /> {customer.phoneNumber}{' '}
                    <br />
                    <span>Asiakkaan Bonus: </span>
                    <br className='mobile-break' /> {customer.accumulatedBonus}{' '}
                    € <br />
                    <button
                      id='gradient_Button'
                      onClick={() => togglePopup(customer)}
                    >
                      Muokkaa asiakkaan
                      <br /> tietoja
                    </button>
                    <Link
                      to={`${URL_EXTENSION}customers/${customer.customerId}`}
                    >
                      <button id='gradient_Button'>Asiakkaan tilaukset</button>
                    </Link>
                    <button
                      id='gradient_Button'
                      onClick={() =>
                        removeCustomer(
                          customer.customerId,
                          customer.phoneNumber,
                          customer.callSign,
                          customer.accumulatedBonus
                        )
                      }
                    >
                      Poista asiakas
                    </button>
                  </div>
                </div>
              ))
            )
          ) : filteredList === undefined ? (
            <LoginRequest />
          ) : filteredList.length === 0 ? (
            <h4>Ei asiakkaita</h4>
          ) : (
            filteredList.map((customer, index) => (
              <div
                className='customer_list'
                key={index}
                id={customer.customerId}
                onClick={() => toggleComment(customer.customerId)}
              >
                {customer.callSign}
                <br />
                <div className={show[customer.customerId] ? 'showCar' : 'hide'}>
                  <span>Asiakkaan ID: </span>
                  <br className='mobile-break' /> {customer.customerId} <br />
                  <span>Asiakkaan puhelinnumero: </span>
                  <br className='mobile-break' /> {customer.phoneNumber} <br />
                  <span>Asiakkaan Bonus: </span>
                  <br className='mobile-break' /> {customer.accumulatedBonus} €{' '}
                  <br />
                  <button
                    id='gradient_Button'
                    onClick={() => togglePopup(customer)}
                  >
                    Muokkaa asiakkaan
                    <br /> tietoja
                  </button>
                  <Link to={`${URL_EXTENSION}customers/${customer.customerId}`}>
                    <button id='gradient_Button'>Asiakkaan tilaukset</button>
                  </Link>
                  <button
                    id='gradient_Button'
                    onClick={() =>
                      removeCustomer(
                        customer.customerId,
                        customer.phoneNumber,
                        customer.callSign,
                        customer.accumulatedBonus
                      )
                    }
                  >
                    Poista asiakas
                  </button>
                </div>
              </div>
            ))
          )}
          <h2>Poistetut asiakkaat</h2>
          {filteredDel === false ? (
            props.deletedCustomerList === undefined ? (
              <LoginRequest />
            ) : props.deletedCustomerList.length === 0 ? (
              <h4>Ei poistettuja asiakkaita</h4>
            ) : (
              props.deletedCustomerList.map((customer, index) => (
                <div
                  className='customer_list'
                  key={index}
                  id={customer.customerId}
                  onClick={() => toggleComment(-customer.customerId)}
                >
                  {customer.callSign}
                  <br />
                  <div
                    className={show[-customer.customerId] ? 'showCar' : 'hide'}
                  >
                    <span>Asiakkaan ID: </span>
                    <br className='mobile-break' /> {customer.customerId} <br />
                    <span>Asiakkaan puhelinnumero: </span>
                    <br className='mobile-break' /> {customer.phoneNumber}{' '}
                    <br />
                    <span>Asiakkaan Bonus: </span>
                    <br className='mobile-break' /> {customer.accumulatedBonus}{' '}
                    € <br />
                    <button
                      id='gradient_Button'
                      onClick={() => togglePopup(customer)}
                    >
                      Muokkaa asiakkaan
                      <br /> tietoja
                    </button>
                    <Link
                      to={`${URL_EXTENSION}customers/${customer.customerId}`}
                    >
                      <button id='gradient_Button'>Asiakkaan tilaukset</button>
                    </Link>
                    <button
                      id='gradient_Button'
                      onClick={() =>
                        restoreCustomer(
                          customer.customerId,
                          customer.phoneNumber,
                          customer.callSign,
                          customer.accumulatedBonus
                        )
                      }
                    >
                      Palauta asiakas aktiiviseksi
                    </button>
                  </div>
                </div>
              ))
            )
          ) : filteredDelList === undefined ? (
            <LoginRequest />
          ) : filteredDelList.length === 0 ? (
            <h4>Ei poistettuja asiakkaita</h4>
          ) : (
            filteredDelList.map((customer, index) => (
              <div
                className='customer_list'
                key={index}
                id={customer.customerId}
                onClick={() => toggleComment(-customer.customerId)}
              >
                {customer.callSign}
                <br />
                <div
                  className={show[-customer.customerId] ? 'showCar' : 'hide'}
                >
                  <span>Asiakkaan ID: </span>
                  <br className='mobile-break' /> {customer.customerId} <br />
                  <span>Asiakkaan puhelinnumero: </span>
                  <br className='mobile-break' /> {customer.phoneNumber} <br />
                  <span>Asiakkaan Bonus: </span>
                  <br className='mobile-break' /> {customer.accumulatedBonus} €{' '}
                  <br />
                  <button
                    id='gradient_Button'
                    onClick={() => togglePopup(customer)}
                  >
                    Muokkaa asiakkaan
                    <br /> tietoja
                  </button>
                  <Link to={`${URL_EXTENSION}customers/${customer.customerId}`}>
                    <button id='gradient_Button'>Asiakkaan tilaukset</button>
                  </Link>
                  <button
                    id='gradient_Button'
                    onClick={() =>
                      restoreCustomer(
                        customer.customerId,
                        customer.phoneNumber,
                        customer.callSign,
                        customer.accumulatedBonus
                      )
                    }
                  >
                    Palauta asiakas asiakas
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
        {isOpen && (
          <ChangeCustomerInfo
            handleClose={togglePopupUpdate}
            customerInfo={popupInfo}
            dispatch={props.dispatch}
          />
        )}
      </div>
    </div>
  )
}

export default CustomerList
